module.exports = __webpack_public_path__ + "static/media/icon_real_time_channelca2e1823a7c557d7f9a086d34b879339.webp";